import { Directive, ElementRef, Input, OnInit } from "@angular/core";

@Directive({
  selector: "[jniPrefixFocusAndSelect]",
})
export class FocusOnShowDirective implements OnInit {
  @Input("jniPrefixFocusAndSelect") flag = true;
  constructor(private el: ElementRef) {
    if (!el.nativeElement.focus) {
      throw new Error("Element does not accept focus.");
    }
  }

  ngOnInit() {
    if (!this.flag) return null;

    const input: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
    input.focus();
    input.select();
    return;
  }
}
